/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiShareLinkType;
(function (ApiShareLinkType) {
    ApiShareLinkType["SHARE_LINK_TYPE_UNKNOWN"] = "ShareLinkTypeUnknown";
    ApiShareLinkType["SHARE_LINK_TYPE_REPORT"] = "ShareLinkTypeReport";
    ApiShareLinkType["SHARE_LINK_TYPE_SYNC"] = "ShareLinkTypeSync";
})(ApiShareLinkType || (ApiShareLinkType = {}));
export function ApiShareLinkTypeFromJSON(json) {
    return ApiShareLinkTypeFromJSONTyped(json, false);
}
export function ApiShareLinkTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiShareLinkTypeToJSON(value) {
    return value;
}
